<section class="subscribe-area ptb-100">
    <div class="container">
        <div class="newsletter">
            <h2>Join Our Newsletter</h2>
            <form class="newsletter-form">
                <input type="email" [(ngModel)]="nemail" [ngModelOptions]="{standalone: true}" class="form-control" placeholder="Enter your email address" name="EMAIL">
                <button class="btn btn-primary" (click)="onSubmitNL()" type="submit">Subscribe</button>
            </form>
        </div>
    </div>
</section>